import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Popover, message, Checkbox } from "antd";
import { find } from 'lodash';

import * as constants from '../../constants';
import RecipientForm from './RecipientForm';

import core from '../../../core';
import uistate from '../../../uistate';
import globalappstate from '../../../globalappstate';
import common from '../../../../common';

const { GenericTable } = core;


class RecipientsGrid extends Component {

    state = {
        addFormVisible: false,
        editFormVisible: false,
        currentEditEntity: {},
    };

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'RecipientsGrid', key);
    }

    //#region Grid button handlers

    onAddClicked = (e) => {
        this.setState({
            currentEditEntity: { idProcessingActivity: this.props.idProcessingActivity, idRecipient: -1 },
            addFormVisible: true,
        });
    }
    onDeleteClicked = (idx) => {
        this.props.arrayHelper.remove(idx);
    }
    onEditClicked = (id) => {
        const editentity = find(this.props.items, { 'idx': id });
        this.setState({
            currentEditEntity: editentity,
            editFormVisible: true,
        });
    }

    //#endregion    

    //#region Form handlers

    handleCancelForm = (e) => {
        this.setState({
            addFormVisible: false,
            editFormVisible: false,
            currentEditEntity: {},
        });
    }
    handleEntityAdd = (values) => {
        this.props.arrayHelper.push(values);
        this.setState({
            addFormVisible: false,
            currentEditEntity: {},
        });
    }

    handleEntityEdit = (values) => {
        this.props.arrayHelper.replace(values.idx, values);
        this.setState({
            editFormVisible: false,
            currentEditEntity: {},
        });
    }


    //#endregion

    render() {
        const readOnly = this.props.readOnly ? this.props.readOnly : false;
        const columns = [{
            title: this.label('Recipient'),
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => ('' + a.name).localeCompare(b.name),
        }, {
            title: this.label('CountryName'),
            dataIndex: 'countryName',
            key: 'countryName',
            sorter: (a, b) => ('' + a.countryName).localeCompare(b.countryName),
        }, {
            title: this.label('EuOrAdequate'),
            dataIndex: 'euOrAdequate',
            key: 'euOrAdequate',
            sorter: (a, b) => ('' + a.euOrAdequate).localeCompare(b.euOrAdequate),
            render: (text, record) => (
                <Checkbox checked={record.euOrAdequate} disabled/>
            )
        }];

        return (
            <div className='recipients'>
                <GenericTable aligntop multiline columns={columns} data={this.props.items} keyfield='idx' itemName={this.label('RecipientItem')} pagesize={5}
                    onAdd={this.onAddClicked}
                    readOnly={readOnly}
                    onDelete={this.onDeleteClicked}
                    onEdit={this.onEditClicked}
                    onDoubleClick={this.onEditClicked} />

                <Modal title={this.label("AddModalTitleForm")} width='80%' destroyOnHidden={true} maskClosable={false}
                    open={this.state.addFormVisible}
                    footer={null}
                    onCancel={this.handleCancelForm}
                >
                    <RecipientForm picklists={this.props.picklists} labels={this.props.labels} datacontext={this.state.currentEditEntity} onCancel={this.handleCancelForm} onSave={this.handleEntityAdd} />
                </Modal>

                <Modal title={this.label("EditModalTitleForm")} width='80%' destroyOnHidden={true} maskClosable={false}
                    open={this.state.editFormVisible}
                    footer={null}
                    onCancel={this.handleCancelForm}
                >
                    <RecipientForm picklists={this.props.picklists} labels={this.props.labels} datacontext={this.state.currentEditEntity} onCancel={this.handleCancelForm} onSave={this.handleEntityEdit} />
                </Modal>

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        picklists: globalappstate.selectors.allPicklists(state),
        labels: uistate.selectors.uiLabels(state),
    };
}

export default connect(mapStateToProps,
    {

    })
    (RecipientsGrid);  